(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!root || !root.document) return;

  function initialize(scope) {
    scope.querySelectorAll('[data-vehicle-finder-test]').forEach(function (element) {
      if (element.dataset.initialized) return;
      element.dataset.initialized = 'true';
      var form = element.querySelector('form');
      var make = element.querySelector('[data-vehicle-make]');
      var model = element.querySelector('[data-vehicle-model]');
      var year = element.querySelector('[data-vehicle-year]');
      var submit = element.querySelector('[data-vehicle-submit]');
      var retry = element.querySelector('[data-vehicle-retry]');
      var status = element.querySelector('[data-vehicle-status]');
      var products = [];
      var busy = false;

      function selection() { return { make: make.value, model: model.value, year: year.value }; }
      function fill(select, field, placeholder) {
        select.replaceChildren();
        var empty = root.document.createElement('option');
        empty.value = '';
        empty.textContent = placeholder;
        select.appendChild(empty);
        var options = api.getOptions(products, field, selection());
        options.forEach(function (item) {
          var option = root.document.createElement('option');
          option.value = item.value;
          option.textContent = item.label;
          select.appendChild(option);
        });
        select.disabled = options.length === 0;
      }
      function updateSubmit() { submit.disabled = busy || !make.value || !model.value || !year.value; }

      make.addEventListener('change', function () {
        model.value = '';
        year.value = '';
        fill(model, 'model', 'Select model');
        fill(year, 'year', 'Select year');
        updateSubmit();
      });
      model.addEventListener('change', function () {
        year.value = '';
        fill(year, 'year', 'Select year');
        updateSubmit();
      });
      year.addEventListener('change', updateSubmit);
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (busy || submit.disabled) return;
        root.location.assign(api.buildSearchUrl(form.action, selection()));
      });

      async function load() {
        if (busy) return;
        busy = true;
        products = [];
        [make, model, year, submit].forEach(function (control) { control.disabled = true; });
        retry.hidden = true;
        status.textContent = 'Loading vehicles…';
        element.setAttribute('aria-busy', 'true');
        try {
          products = await api.loadCatalog(element.dataset.catalogUrl, root.fetch.bind(root));
          fill(make, 'make', 'Select make');
          fill(model, 'model', 'Select model');
          fill(year, 'year', 'Select year');
          status.textContent = make.disabled ? 'No tagged vehicles are available yet.' : 'Choose your make, model and year.';
        } catch (error) {
          status.textContent = 'Vehicle options could not load. Please try again.';
          retry.hidden = false;
          root.console.warn('Vehicle finder test:', error.message);
        } finally {
          busy = false;
          element.setAttribute('aria-busy', 'false');
          updateSubmit();
        }
      }
      retry.addEventListener('click', load);
      load();
    });
  }
  if (root.document.readyState === 'loading') {
    root.document.addEventListener('DOMContentLoaded', function () { initialize(root.document); });
  } else {
    initialize(root.document);
  }
  root.document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var fields = { make: /^make:\s*(.+)$/i, model: /^model:\s*(.+)$/i, year: /^year:\s*(\d{4})\s*$/i };

  function getOptions(products, field, selection) {
    if (!fields[field]) throw new Error('Invalid vehicle field.');
    selection = selection || {};
    if (field !== 'make' && !selection.make) return [];
    if (field === 'year' && !selection.model) return [];
    var options = new Map();
    products.forEach(function (product) {
      var tags = Array.isArray(product.tags) ? product.tags : [];
      if (field !== 'make' && tags.indexOf(selection.make) === -1) return;
      if (field === 'year' && tags.indexOf(selection.model) === -1) return;
      tags.forEach(function (tag) {
        if (typeof tag !== 'string') return;
        var match = fields[field].exec(tag);
        if (match) options.set(tag, { value: tag, label: match[1].trim() });
      });
    });
    return Array.from(options.values()).sort(function (a, b) {
      return field === 'year' ? Number(b.label) - Number(a.label) : a.label.localeCompare(b.label);
    });
  }

  function buildSearchUrl(searchUrl, selection) {
    var query = ['make', 'model', 'year'].map(function (field) {
      var value = selection && selection[field];
      if (typeof value !== 'string' || !fields[field].test(value)) throw new Error('Complete vehicle selection required.');
      return 'tag:"' + value.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
    }).join(' AND ');
    var base = typeof window !== 'undefined' ? window.location.href : 'https://vehicle-finder.invalid';
    var url = new URL(searchUrl, base);
    url.search = '';
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'none');
    return url.pathname + url.search;
  }

  async function loadCatalog(dataUrl, fetchFn) {
    var base = typeof window !== 'undefined' ? window.location.href : 'https://vehicle-finder.invalid';
    var url = new URL(dataUrl, base);
    var origin = url.origin;
    url.searchParams.set('view', 'vehicle-finder-data');
    url.searchParams.set('page', '1');
    var products = [];
    var ids = new Set();
    var expectedTotal;
    var expectedPages;
    var expectedPage = 1;
    while (url) {
      if (url.origin !== origin) throw new Error('Catalogue pagination changed origin.');
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 20000);
      var data;
      try {
        var response = await fetchFn(url.href, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error('Catalogue request failed (' + response.status + ').');
        try { data = await response.json(); }
        catch (error) { throw new Error('Invalid catalogue JSON. Check the collection data template.'); }
      } finally {
        clearTimeout(timeout);
      }
      if (!data || !Array.isArray(data.products) || !Number.isInteger(data.total) || data.total < 0 ||
          !Number.isInteger(data.pages) || data.pages < 0 || data.page !== expectedPage ||
          (data.next !== null && typeof data.next !== 'string')) {
        throw new Error('Invalid catalogue response. Check the collection data template.');
      }
      if (data.total > 25000 || data.pages > 100) throw new Error('This test supports up to 25,000 products.');
      if (expectedTotal === undefined) { expectedTotal = data.total; expectedPages = data.pages; }
      if (data.total !== expectedTotal || data.pages !== expectedPages) throw new Error('Catalogue changed during loading. Please retry.');
      data.products.forEach(function (product) {
        if (!product || product.id == null || !Array.isArray(product.tags) ||
            product.tags.some(function (tag) { return typeof tag !== 'string'; }) || ids.has(String(product.id))) {
          throw new Error('Invalid or duplicate catalogue product. Please retry.');
        }
        ids.add(String(product.id));
        products.push(product);
      });
      if (!data.next) {
        if (products.length !== expectedTotal || expectedPage !== Math.max(1, expectedPages)) throw new Error('Incomplete catalogue response.');
        return products;
      }
      if (expectedPage >= expectedPages || expectedPage >= 100) throw new Error('Invalid catalogue pagination.');
      var next = new URL(data.next, url);
      if (next.origin !== origin) throw new Error('Catalogue pagination changed origin.');
      next.searchParams.set('view', 'vehicle-finder-data');
      expectedPage += 1;
      if (Number(next.searchParams.get('page')) !== expectedPage) throw new Error('Invalid catalogue pagination sequence.');
      url = next;
    }
    throw new Error('Incomplete catalogue response.');
  }
  return { getOptions: getOptions, buildSearchUrl: buildSearchUrl, loadCatalog: loadCatalog };
}));
